export const DISNEY_OFFER_CODES: string[] = ['6ZW7C', '53KLC', '6JG4C'];
export const DISNEY_DINING_CARD_CODES: string[] = ['5X67C', '5QCPC', '1MB6C'];
export const DISNEY_FREE_MEAL_PLAN_CODES: string[] = ['1JJPC', '84K6C', '8BCJC'];
